import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { usePostUsersLogout } from '@/shared/api'
import { AXIOS_INSTANCE } from '@/shared/api/axios-client'

import { useAuthCitySetter } from '../../model/hooks/use-auth-city.setter'
import { useAuthProfileSetter } from '../../model/hooks/use-auth-profile.setter'
import { useAuthTokenSetter } from '../../model/hooks/use-auth-token.setter'

export const useLogout = () => {
    const { tokenSetter } = useAuthTokenSetter()
    const { profileSetter } = useAuthProfileSetter()
    const { citySetter } = useAuthCitySetter()
    const queryClient = useQueryClient()

    const { mutateAsync: logoutAsync, isPending } = usePostUsersLogout({
        mutation: {
            onSuccess: () => {
                tokenSetter(undefined)
                profileSetter(undefined)
                citySetter(null)
                /**
                 * Clear webim authorized visitor
                 */
                webim_visitor = null
                webim.api.onProvidedVisitorChanged()

                /**
                 * Clear the axios instance headers
                 */
                AXIOS_INSTANCE.defaults.headers.Authorization = ''

                /**
                 * Clear the tanstack-query cache
                 */
                setTimeout(() => {
                    queryClient.clear()
                }, 400)

                toast.success('Вы успешно вышли из системы')
            },
            onError: () => {
                toast.error('Не удалось выйти из системы')
            },
        },
    })

    return { logoutAsync, isPending }
}
